import { useMutation } from '@tanstack/react-query';
import { SaveContextRequest } from '@/types/request/SaveContextRequest';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { queryClient } from '@/main.tsx';
import BackendClient from '@/api/backendClient.ts';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';
import { UserContext } from '@/models/UserContext';

const useUserContextSave = () => {
  const mutationFn = async (request: SaveContextRequest) => {
    return saveContext(request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['user_context'] });
    },
  });
};

export default useUserContextSave;

async function saveContext(request: SaveContextRequest): Promise<UserContext> {
  try {
    const response = await BackendClient.post<BackendSuccessResponse<UserContext>>('/api/chat/context', request);

    return response.data.data;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while saving user context.');
  }
}
